export default __webpack_public_path__ + "static/poster-f7589ae5a3e9bc005197af3cdd8a4fd5.png";